export const SITE_HEADER_COLOR = "#364958";
export const APP_HEADER_COLOR = "#00a3a3";
export const RISE_HEADER_COLOR = "#63173e";
export const READING_HEADER_COLOR = "#08181b";
export const WHEEL_APP_HEADER_COLOR = "#f5f2e8";

export function themeColorForRoute(path = "/") {
  if (path === "/" || path === "/voor-ouders" || path === "/app") {
    return SITE_HEADER_COLOR;
  }
  if (path === "/rise-by-eva" || path === "/custom-profile") {
    return RISE_HEADER_COLOR;
  }
  if (path === "/reading" || path === "/mini-reading") {
    return READING_HEADER_COLOR;
  }
  if (path === "/app-preview") return WHEEL_APP_HEADER_COLOR;
  return APP_HEADER_COLOR;
}

export function syncBrowserThemeColor(color) {
  if (typeof document === "undefined") return;
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", color);
}
